import React from "react"
import { Text } from "@mantine/core"
import { useStyles } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/FavoritesRecentsTabs.styles"
import { Icon } from "@/components"
import { QuorumTheme } from "app/static/frontend/design-constants"

export const EmptyTab = ({ icon, title, description }) => {
    const { classes } = useStyles()

    return (
        <div className={classes.emptySearchContainer}>
            <div className={classes.emptySearchIcon}>
                <Icon icon={icon} color={QuorumTheme.colors.violet[5]} />
            </div>
            <div className={classes.emptySearchTextContainer}>
                <Text className={classes.emptySearchTitle}>{title}</Text>
                <Text className={classes.emptySearchText}>{description}</Text>
            </div>
        </div>
    )
}
